import { render, staticRenderFns } from "./HighlightedPosts.vue?vue&type=template&id=3681387e&scoped=true&"
import script from "./HighlightedPosts.vue?vue&type=script&lang=js&"
export * from "./HighlightedPosts.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedPosts.vue?vue&type=style&index=0&id=3681387e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681387e",
  null
  
)

export default component.exports